import React, { useEffect, useRef, useState } from 'react'
import prevArrow from '../../../../../src/assets/images/products/left_arrow.png';
import rightOPtion from '../../../../../src/assets/images/products/right_burger_icon.png';
import locationIcon from '../../../../../src/assets/images/location_icon.png'
import './ProfileDetails.scss'
import jobIcon from '../../../../../src/assets/images/job_icon.png';
import lockIcon from '../../../../../src/assets/images/lock_icon.png';
import jobIcon2 from '../../../../../src/assets/images/job_icon2.png';
import foodIcon from '../../../../../src/assets/images/food_icon.png';
import drinkingIcon from '../../../../../src/assets/images/drinking_icon.png';
import smokingIcon from '../../../../../src/assets/images/smoker_icon.png';
import ideologyIcon from '../../../../../src/assets/images/ideology_icon.png';
import circle from '../../../../assets/images/products/circle_img.png'
import contactButton from '../../../../assets/images/products/contact_button.png'
import headerTop from '../../../../assets/images/products/header_top_white.png';
import InterestButton from '../../../../assets/images/interest_button.png';

const ProfileDetails = ({ children, currentTime, profileData = {}, className }) => {
    let [parent, child] = [useRef(), useRef()]
    const [scrollArrowVisible, setScrollArrowVisible] = useState(false)
    const [currentImageIndex, setCurrentImageIndex] = useState(0)

    console.log('profileData changed', profileData)


    useEffect(() => {
        if (parent.current && child.current) {
            const parentHeight = parent.current.offsetHeight;
            const childHeight = child.current.offsetHeight;
            setScrollArrowVisible(childHeight + 50 < parentHeight)
        }
    }, [parent, child]);

    // Helper function to safely extract values from objects
    const getValue = (value, fallback = 'Not specified') => {
        if (value === null || value === undefined) return fallback;
        if (typeof value === 'object') {
            if (value.label) return value.label;
            if (value.name) return value.name;
            if (value.value) return value.value;
        }
        if (typeof value === 'string') {
            const trimmed = value.trim();
            return trimmed.length ? trimmed : fallback;
        }
        if (typeof value === 'number' || typeof value === 'boolean') {
            return String(value);
        }
        return fallback;
    };

    // Helper to gather education from multiple possible payload shapes
    const getEducationValue = (profileData) => {
        const educationCandidates = [
            profileData?.education,
            profileData?.education_details,
            profileData?.education_detail,
            profileData?.educational_qualification,
            profileData?.qualification,
            profileData?.originalData?.education,
            profileData?.originalData?.education?.label,
            profileData?.profile_preview?.education,
            profileData?.profilePreview?.education
        ];

        for (const candidate of educationCandidates) {
            const formatted = getValue(candidate);
            if (formatted && formatted !== 'Not specified') {
                return formatted;
            }
        }

        return 'Not specified';
    };

    // Helper function to get marital status - matching ListingView format
    const getMaritalStatus = (maritalStatus) => {
        if (!maritalStatus) return 'Not specified';
        if (typeof maritalStatus === 'object' && maritalStatus.label) return maritalStatus.label;
        if (typeof maritalStatus === 'string') return maritalStatus;
        // Handle case where maritalStatus might be a code
        if (typeof maritalStatus === 'object' && maritalStatus.code) {
            // Map common codes to labels
            const codeMap = {
                '0': 'Single',
                '1': 'Divorced', 
                '2': 'Widowed',
                '3': 'Separated'
            };
            return codeMap[maritalStatus.code] || maritalStatus.code;
        }
        return 'Not specified';
    };


    // Helper function to get location from profileData with multiple fallbacks - updated for payload structure
    const getLocationFromProfileData = (profileData, type = 'city') => {
        // First try the direct city/state fields from payload structure
        let locationValue = 'Not specified';
        
        if (type === 'city') {
            // Try different possible city fields from payload
            locationValue = profileData.city?.name ||
                           profileData.city?.city?.label ||
                           profileData.city?.label ||
                           profileData.city?.display_place ||
                           profileData.city?.display_name ||
                           profileData?.location ||
                           profileData?.city||
                           'Not specified';
        } else if (type === 'state') {
            // Try different possible state fields from payload
            locationValue = profileData.state?.label ||
                        profileData?.state ||
                           profileData.city?.state?.label ||
                           profileData.locationData?.state?.label ||
                           'Not specified';
        }
        
        // If still not found and we have a raw location string, try to extract from it
        if (locationValue === 'Not specified' && profileData.location && type === 'city') {
            // If location is a string like "Kochi, Kerala", extract the city part
            const locationStr = profileData.location;
            if (typeof locationStr === 'string' && locationStr.includes(',')) {
                locationValue = locationStr.split(',')[0].trim();
            } else if (typeof locationStr === 'string' && locationStr.trim()) {
                locationValue = locationStr.trim();
            }
        }
        
        // If still not found and we have a raw location string, try to extract state from it
        if (locationValue === 'Not specified' && profileData.location && type === 'state') {
            // If location is a string like "Kochi, Kerala", extract the state part
            const locationStr = profileData.location;
            if (typeof locationStr === 'string' && locationStr.includes(',')) {
                const parts = locationStr.split(',');
                if (parts.length > 1) {
                    locationValue = parts[1].trim();
                }
            }
        }
        
        return locationValue || 'Not specified';
    };

    // Helper function to format height display - matching ListingView format
    const formatHeightDisplay = (heightData) => {
        if (!heightData) return 'Not specified';
        
        let heightLabel = '';
        if (typeof heightData === 'object' && heightData.label) {
            heightLabel = heightData.label;
        } else if (typeof heightData === 'string') {
            heightLabel = heightData;
        } else if (typeof heightData === 'object' && heightData.code) {
            // Handle case where heightData might be just a code
            heightLabel = heightData.code;
        } else {
            return 'Not specified';
        }

        let text = heightLabel.trim();

        // If format like "124 cm / 4 ft 1 in" -> take part after '/'
        if (text.includes('/')) {
            const parts = text.split('/');
            text = parts[parts.length - 1].trim();
        }

        // If format like "4 ft 1 in" or "4ft 1in" -> convert to 4'1"
        const feetInchesMatch = text.match(/(\d+)\s*ft\s*(\d+)\s*in/i);
        if (feetInchesMatch) {
            const [, ft, inch] = feetInchesMatch;
            return `${ft}'${inch}"`;
        }

        // If already in the correct format (e.g., "4'1""), return as is
        if (text.match(/^\d+'\d+"$/)) {
            return text;
        }

        // Handle case where we only have a number (like "124")
        if (text.match(/^\d+$/)) {
            // This might be a height code, try to convert
            const heightCode = parseInt(text);
            if (heightCode > 0) {
                // Convert cm to feet and inches
                const totalInches = heightCode / 2.54;
                const feet = Math.floor(totalInches / 12);
                const inches = Math.round(totalInches % 12);
                return `${feet}'${inches}"`;
            }
        }

        // Fallback: remove any trailing cm portion if provided first
        const cmRemoved = text.replace(/\b\d+\s*cm\b.*$/i, '').trim();
        return cmRemoved || text;
    };

    // Helper function to calculate age from date of birth
    const calculateAge = (dob) => {
        if (!dob) return 0;
        
        try {
            const date = new Date(dob);
            if (isNaN(date.getTime())) {
                return 0;
            }

            const today = new Date();
            let age = today.getFullYear() - date.getFullYear();
            const monthDiff = today.getMonth() - date.getMonth();
            
            if (monthDiff < 0 || (monthDiff === 0 && today.getDate() < date.getDate())) {
                age--;
            }
            
            return age;
        } catch (error) {
            console.error('Error calculating age:', error);
            return 0;
        }
    };

    // Helper function to format date of birth for display
    const formatDOB = (dob) => {
        if (!dob) return 'Not specified';
        
        try {
            const date = new Date(dob);
            if (isNaN(date.getTime())) {
                return 'Not specified';
            }
            
            // Format as DD-MM-YYYY
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0');
            const year = date.getFullYear();
            
            return `${day}-${month}-${year}`;
        } catch (error) {
            console.error('Error formatting DOB:', error);
            return 'Not specified';
        }
    };

    // Get profile data from props or use mock data
    const profile = profileData && Object.keys(profileData).length > 0 ? {
        name: getValue(profileData.name, 'Not specified'),
        lumi_id: getValue(profileData.lumi_id, 'Not specified'),
        age: profileData.age || calculateAge(profileData.dob),
        dob: formatDOB(profileData.dob),
        height: formatHeightDisplay(profileData.height),
        marital_status: getMaritalStatus(profileData.marital_status),
        religion: getValue(profileData.religion, 'Not specified'),
        caste: getValue(profileData.caste, 'Not specified'),
        zodiac_sign: getValue(profileData.zodiac_sign, 'Not specified'),
        city: getLocationFromProfileData(profileData, 'city'),
        state: getLocationFromProfileData(profileData, 'state'),
        about_me: profileData.bio || profileData.about_me || 'Not specified',
        job: getValue(profileData.job, 'Not specified'),
        company: getValue(profileData.company, 'Not specified'),
        education: getEducationValue(profileData),
        country: getValue(profileData.country, 'Not specified'),
        profile_images: profileData.profile_images || [],
        compatibility_score: profileData.compatibility_score || 0
    } : {
        name: "Test 123",
        lumi_id: "MB6AF8020AAD",
        age: 21,
        dob: "10-02-2004",
        height: "4'1\"",
        marital_status: "Divorced",
        religion: "Hindu",
        caste: "24 Manai Telugu Chettiar",
        zodiac_sign: "Bharani",
        city: "Kochi",
        state: "Kerala",
        about_me: "bi bkdsfk sad dsafds af",
        job: "Accountant",
        company: "Not specified",
        country: "India",
        education: "B.Tech in Computer Science",
        profile_images: [
            { original: "https://via.placeholder.com/300x400/ff6b6b/ffffff?text=Profile+1" },
            { original: "https://via.placeholder.com/300x400/4ecdc4/ffffff?text=Profile+2" },
            { original: "https://via.placeholder.com/300x400/45b7d1/ffffff?text=Profile+3" }
        ],
        compatibility_score: 82
    };


    const handleImageChange = (index) => {
        setCurrentImageIndex(index);
    };


    return (
        <>
            <div className={`app`} ref={parent}>
                <div className={`profile_details_view ${className} ${scrollArrowVisible && 'scrollable_arrow'} `} ref={child}>
                    {/* <header className="app__header transparent">
                        <div className="app__header__top">
                            <div className="app__header__top__icons">
                                <img src={topIconSetDark} alt="" />
                            </div>
                        </div>
                    </header> */}
                    <main className="app__main" style={{ paddingTop: 0 }}>
                        <div className="app__profile-container">
                            <div className="app__header transparent app__header___top">
                                <div className="header_top_image">
                                    <img src={headerTop} alt="" />
                                </div>
                                <div className="app__back-button">
                                    <img src={prevArrow} alt="" />
                                </div>
                                {/* <div className="app__title">Profile Details</div> */}
                                <div className="app__heart-button">
                                    <img src={rightOPtion} alt="" />
                                </div>
                            </div>

                            {/* Profile Image Section */}
                            <div className="app__profile-image-section">
                                <div className="app__profile-main-image">
                                    {profile.profile_images && profile.profile_images.length > 0 ? (
                                        <img
                                            className='profile-cover'
                                            src={profile.profile_images[currentImageIndex]?.original}
                                            alt={`Profile ${currentImageIndex + 1}`}
                                        />
                                    ) : (
                                        <div className="no-image-placeholder">
                                            No profile images added
                                        </div>
                                    )}

                                    {/* Image indicators */}
                                    {profile.profile_images && profile.profile_images.length > 1 && (
                                        <div className="app__image-indicators">
                                            {profile.profile_images.map((_, index) => (
                                                <div
                                                    key={index}
                                                    className={`indicator ${index === currentImageIndex ? 'active' : ''}`}
                                                    onClick={() => handleImageChange(index)}
                                                />
                                            ))}
                                        </div>
                                    )}

                                    {/* Compatibility Score */}
                                    <div className="app__compatibility-score">
                                        <div className="score-circle">
                                            <span className="score-percentage">
                                                <img src={circle} alt="" />
                                            </span>
                                        </div>
                                    </div>
                                    <ul className="custom_dots">
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                        <li></li>
                                    </ul>
                                </div>
                            </div>

                            {/* Profile Details Card */}
                            <div className="app__profile-card">
                                <div className="app__profile-header">
                                    <div className="app__profile-name-section">
                                        <div className="app__profile-name text_blue200">Bureau Profile</div>
                                        <div className="app__profile-id" style={{ textTransform: 'capitalize'}}>
                                            {profile.name && profile.name !== 'Not specified'
                                                ? profile.name
                                                : (profile.lumi_id && profile.lumi_id !== 'Not specified'
                                                    ? profile.lumi_id
                                                    : 'Not specified')}
                                        </div>
                                    </div>
                                    <button className="app__direct-call-btn">Direct Call Support</button>
                                </div>

                                {/* Basic Info Tags */}
                                <div className="app__profile-tags">
                                    <div className="app__tag">{profile.height}</div>
                                    <div className="app__tag">{profile.marital_status}</div>
                                    <div className="app__tag">{profile.age} years, {profile.dob}</div>
                                </div>

                                {/* Religion and Location */}
                                <div className="app__profile-details">
                                    <div className="app__religion"> {profile.religion}, {profile.caste}</div>
                                    <div className="app__location">
                                        <span className="location-icon">
                                            <img src={locationIcon} alt="location" />
                                        </span>
                                        {profile.city === 'Not specified' && profile.state === 'Not specified' 
                                            ? 'Location not specified' 
                                            : `${profile.city || profile.location}, ${profile.state}`}
                                    </div>
                                </div>

                                {/* About Me Section */}
                                <div className="app__about-section">
                                    <div className="app__about-text">{profile.about_me}</div>
                                </div>

                                {/* Siblings Box */}
                                {/* <div style={{
                                    border: '1px solid #f0b3b3',
                                    borderRadius: '10px',
                                    padding: '10px 14px',
                                    width: '160px',
                                    margin: '10px 0'
                                }}>
                                    <div style={{ textAlign: 'center', color: '#ff5a5a', marginBottom: '6px' }}>Siblings</div>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '6px' }}>
                                        <span style={{ color: '#333' }}>Brother(s) :</span>
                                        <span style={{ background: '#f0f0f0', borderRadius: '6px', padding: '2px 8px', minWidth: '28px', textAlign: 'center' }}>{brothers}</span>
                                    </div>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
                                        <span style={{ color: '#333' }}>Sister(s) :</span>
                                        <span style={{ background: '#f0f0f0', borderRadius: '6px', padding: '2px 8px', minWidth: '28px', textAlign: 'center' }}>{sisters}</span>
                                    </div>
                                </div> */}

                                {/* Action Buttons */}
                                <div className="app__action-buttons">
                                    <div className="app__action-text">Send a request and connect!</div>
                                    <button className="app__send-interest-btn"> <img src={InterestButton} alt="" /></button>
                                </div>

                                {/* Contact Options */}
                                <div className="app__contact-options">
                                    <div className="app__contact-text">Access Phone Number</div>
                                    <button className="app__contact-btn phone-btn">
                                        <img src={contactButton} alt="" />
                                    </button>
                                </div>

                                {/* Expandable Sections */}
                                <div className="app__expandable-sections">
                                    <div className="wrap">
                                        <div className="app__expandable-item">
                                            <span className="expandable-icon">
                                                <img src={jobIcon} alt="" />
                                            </span>
                                            <span className="expandable-text text_red">Job & Education</span>
                                            <span><img src={lockIcon} alt="" /></span>
                                        </div>
                                        <div>
                                            <div className="short_content_wrap">
                                                <div className="short_parent">
                                                    <div>
                                                        <img src={jobIcon2} alt="" />
                                                        <div>
                                                            <span>Job</span>
                                                            <span>{profile.job}</span>
                                                            {/* <span>{'FlipTree'}</span> */}
                                                            {/* <span>{'India'}</span> */}
                                                        </div>
                                                    </div>
                                                    <div>
                                                        <img src={jobIcon2} alt="" />
                                                        <div>
                                                            <span>Education</span>
                                                            <span>{profile.education}</span>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>

                                        </div>
                                    </div>
                                    <div className="wrap">
                                        <div className="app__expandable-item">
                                            <span className="expandable-icon">
                                                <img src={jobIcon} alt="" />
                                            </span>
                                            <span className="expandable-text text_red positioned_text">Lifestyle</span>
                                            <span><img src={lockIcon} alt="" /></span>
                                        </div>
                                        <div className="short_content_wrap grid_4">
                                            <div>
                                                <img src={foodIcon} alt="" />
                                                <div>
                                                    <span>Food</span>
                                                    <span>Non Vegiterian</span>
                                                </div>
                                            </div>
                                            <div>
                                                <img src={smokingIcon} alt="" />
                                                <div>
                                                    <span>Smoking</span>
                                                    <span>Non Smoker</span>
                                                </div>
                                            </div>
                                            <div>
                                                <img src={drinkingIcon} alt="" />
                                                <div>
                                                    <span>Drinking</span>
                                                    <span>Occasional Drinker</span>
                                                </div>
                                            </div>
                                            <div>
                                                <img src={ideologyIcon} alt="" />
                                                <div>
                                                    <span>Ideologies & Beliefs</span>
                                                    <span>Spiritual</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* <div className="wrap last_wrap">
                                        <div className="app__expandable-item">
                                            <span className="expandable-icon">
                                                <img src={jobIcon} alt="" />
                                            </span>
                                            <span className="expandable-text">Job & Education</span>
                                            <span><img src={lockIcon} alt="" /></span>
                                        </div>
                                     
                                    </div> */}
                                </div>

                            </div>
                        </div>
                    </main>
                </div>
            </div>

        </>
    )
}

export default ProfileDetails